export const fbToMeta = (channel, lowercase, icon) => {
    if (channel === 'facebook' || channel === 'Facebook') {
        if (lowercase && icon) {
            return 'meta-blue';
        }
        if (lowercase) {
            return 'meta';
        }
        return 'Meta';
    } else {
        return channel;
    }
};
